"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewByCodeFilter = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const faCheckCircle_1 = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
const InputString_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputString"));
const Button_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/Button"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
/**
 * Textbox input for access code filter
 *
 * @param param0 description of the filtered column
 * @returns
 */
const InterviewByCodeFilter = ({ t, column: { filterValue, setFilter } }) => {
    const [currentValue, setCurrentValue] = react_1.default.useState(!(0, LodashExtensions_1._isBlank)(filterValue) && filterValue.value ? filterValue.value : filterValue);
    return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement("label", { htmlFor: 'accessCodeSearchInput' }, t('admin:interviewByCodeFilter:title')),
        react_1.default.createElement(InputString_1.default, { id: "accessCodeSearchInput", value: currentValue, onValueUpdated: (newValue) => setCurrentValue(newValue.value) }),
        react_1.default.createElement(Button_1.default, { onClick: () => setFilter(!(0, LodashExtensions_1._isBlank)(currentValue) ? { value: currentValue, op: 'eq' } : currentValue), icon: faCheckCircle_1.faCheckCircle, label: "", size: "small", title: t('admin:interviewByCodeFilter:button') })));
};
exports.InterviewByCodeFilter = InterviewByCodeFilter;
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(exports.InterviewByCodeFilter);
//# sourceMappingURL=InterviewByCodeFilter.js.map